module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main